// Inventory All per-warehouse columns (Stitches S5, flag inventory.allShowroomColumns). The API
// sends warehouseQuantities only when the flag is on and no warehouse is selected.

export interface WarehouseQuantity {
  warehouseId: string | null;
  warehouseName: string;
  quantity: number;
}

export interface WarehouseQuantityColumn {
  key: string;
  warehouseId: string | null;
  title: string;
}

type RowWithWarehouseQuantities = { warehouseQuantities?: WarehouseQuantity[] | null };

const columnKeyFor = (warehouseId: string | null) => `warehouse:${warehouseId ?? 'none'}`;

// Every warehouse any row has, in the order the API sends them.
export const warehouseQuantityColumns = (
  rows: RowWithWarehouseQuantities[],
): WarehouseQuantityColumn[] => {
  const columns = new Map<string, WarehouseQuantityColumn>();
  rows.forEach((row) => {
    (row.warehouseQuantities ?? []).forEach((entry) => {
      const key = columnKeyFor(entry.warehouseId);
      if (!columns.has(key)) {
        columns.set(key, { key, warehouseId: entry.warehouseId, title: entry.warehouseName });
      }
    });
  });
  return Array.from(columns.values());
};

export const warehouseQuantityFor = (
  row: RowWithWarehouseQuantities,
  column: WarehouseQuantityColumn,
): number =>
  (row.warehouseQuantities ?? []).find((entry) => columnKeyFor(entry.warehouseId) === column.key)
    ?.quantity ?? 0;
